import type React from "react"
import { Platform } from "react-native"

import { CloseIconButton } from "@/theme/Button"

import { TitleWithIcon } from "./TitleWithIcon"

import type { TitleWithIconProps } from "./TitleWithIcon"

export function ScreenHeader({
  id = "screenHeader",
  onClose,
  rightElement,
  ...props
}: TitleWithIconProps & { onClose?: () => void }) {
  if (Platform.OS === "ios" || Platform.OS === "android") {
    return null
  }
  if (typeof rightElement === "undefined" && onClose) {
    rightElement = <CloseIconButton onPress={onClose} />
  }
  return (
    <TitleWithIcon
      id={id}
      mb={"$2"}
      mt={"$2"}
      rightElement={rightElement}
      {...props}
    />
  )
}
